<div id="objectives-loading" *ngIf="loading">
    <p>Cargando...</p>
</div>

<div id="objectives-error" *ngIf="!loading && error" class="text-danger">
    <i class="fa fa-times"></i>
    <span>Error</span>
</div>

<div id="objectives" *ngIf="!loading && !error" class="m-3">

    <h1 id="objectives-title" class="mb-3">
        {{ title }}
    </h1>

    <div id="objectives-content" *ngIf="!import">

        <div id="objectives-capabilities-empty" *ngIf="capabilities.length == 0">
            <p>No hay objetivos.</p>
        </div>

        <ul id="objectives-capabilities" class="mb-4" *ngIf="capabilities.length > 0">
            <li *ngFor="let capability of capabilities">
                <p class="fw-bold">Objetivo Específico</p>
                <div class="mb-3">
                    <span class="fw-bold me-3" (click)="showEdit($event)">{{ capability.code }}:</span>
                    <input type="text" class="d-none me-3" pattern="C[0-9]+" data-field="code" [attr.data-id]="capability.id" [attr.value]="capability.code" (keydown.enter)="editCapability($event)" (keydown.esc)="hideEdit($event)">
                    <span (click)="showEdit($event)">{{ capability.content }}</span>
                    <input type="text" class="d-none me-3" [attr.data-id]="capability.id" data-field="content" [attr.value]="capability.content" (keydown.enter)="editCapability($event)" (keydown.esc)="hideEdit($event)">
                    <span class="ms-3" name="delete-capability" title="Eliminar objetivo específico" [attr.data-id]="capability.id" (click)="deleteCapability(capability.id)"><i class="fas fa-times text-danger"></i></span>
                </div>

                <div id="capability-criteria-empty" *ngIf="capability.criteria.length == 0">
                    <p>No hay criterios específicos para este objetivo.</p>
                </div>

                <ul id="capability-criteria" class="mb-4" *ngIf="capability.criteria.length > 0">
                    <li *ngFor="let criteria of capability.criteria">
                        <div class="mb-3">
                            <span class="fw-bold me-3" (click)="showEdit($event)">{{ criteria.code }}:</span>
                            <input type="text" class="d-none me-3" pattern="CE[0-9]+\.[0-9]+" data-field="code" [attr.data-id]="criteria.id" [attr.value]="criteria.code" (keydown.enter)="editCriteria($event)" (keydown.esc)="hideEdit($event)">
                            <span (click)="showEdit($event)">{{ criteria.content }}</span>
                            <input type="text" class="d-none me-3" [attr.data-id]="criteria.id" data-field="content" [attr.value]="criteria.content" (keydown.enter)="editCriteria($event)" (keydown.esc)="hideEdit($event)">
                            <span class="ms-3" name="delete-criteria" title="Eliminar criterio específico" [attr.data-id]="criteria.id" (click)="deleteCriteria(criteria.id)"><i class="fas fa-times text-danger"></i></span>
                        </div>
                    </li>
                </ul>

                <button class="btn btn-success ms-4" name="add-criteria" [attr.data-id]="capability.id" (click)="addCriteria($event)">
                    <i class="fa fa-plus"></i>
                    <span>Añadir criterio específico</span>
                </button>

                <hr>
                
            </li>
        </ul>
        
    </div>

    <div id="objectives-import" *ngIf="import">

        <label for="" class="mb-3">
            <p class="fw-bold">Texto:</p>
            <p class="fw-bold">Importante: uno por línea, cada línea debe empezar con C o CE</p>
            <textarea [(ngModel)]="importText" rows="25" cols="100" class="form-control"></textarea>
        </label>

        <div id="import-status" class="mb-3">
            <div id="import-loading" *ngIf="importLoading">
                <i class="fas fa-spinner fa-spin"></i>
                <span>Importando...</span>
            </div>
            <div id="import-success" class="text-success" *ngIf="importSuccess">
                <i class="fas fa-check"></i>
                <span>¡Objetivos importados correctamente!</span>
            </div>
            <div id="import-error" class="text-danger" *ngIf="importError">
                <i class="fas fa-times"></i>
                <span>Error</span>
            </div>
        </div>

        <button class="btn btn-success d-block mb-3" (click)="importObjectivesText(importText)" [attr.disabled]="importLoading ? 'disabled' : null">
            <i class="fas fa-plus"></i>
            <span>Importar</span>
        </button>
    </div>

    <div id="buttons">
        <button class="btn btn-success d-block mb-3" name="add-capability" (click)="addCapability($event)" *ngIf="!import">
            <i class="fas fa-plus"></i>
            <span>Añadir objetivo específico</span>
        </button>

        <button class="btn btn-success d-block mb-3" (click)="import = !import">
            <div *ngIf="!import">
                <i class="fas fa-list-check" style="color: white !important"></i>
                <i class="fas fa-plus"></i>
                <span>Importar objetivos desde texto</span>
            </div>
            <div *ngIf="import" (click)="getObjectives(id)">
                <i class="fas fa-list-check" style="color: white !important"></i>
                <i class="fas fa-eye"></i>
                <span>Ver objetivos</span>
            </div>
        </button>
    </div>
</div>